import { render, staticRenderFns } from "./IndustryComparisonSection.vue?vue&type=template&id=7f624c82&"
import script from "./IndustryComparisonSection.vue?vue&type=script&setup=true&lang=js&"
export * from "./IndustryComparisonSection.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports